<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    :title="isEdit?'تعديل الباقة':'انشاء باقة'"
    @change="$emit('input',false)"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row class="align-items-center">
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.name"
            :label="$t('page.package-name')"
            is-required
          />
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <b-col
          md="6"
          class="mt-2"
        >
          <b-form-checkbox
            v-model="form.reply"
            switch
          >
            {{ $t('reply.menu-title') }} ?
          </b-form-checkbox>
        </b-col>
        <template v-if="form.reply">
          <b-col
            md="6"
            sm="12"
          >
            <ok-text-input
              v-model="form.reply_num"
              rules="integer"
              :label="$t('reply.replies_count')"
              is-required
            />
          </b-col>
          <b-col
            md="6"
            class="mt-2"
          >
            <b-form-checkbox
              v-model="form.multi_comment"
              switch
            >
              {{ $t('reply.multi_comment') }} ?
            </b-form-checkbox>
          </b-col>
          <b-col
            v-if="form.multi_comment"
            md="6"
            sm="12"
          >
            <ok-text-input
              v-model="form.multi_comment_num"
              rules="integer"
              :label="$t('reply.form.comment-number')"
              is-required
            />
          </b-col>
        </template>
      </b-row>
      <b-row class="align-items-center">
        <b-col
          md="6"
          class="mt-2"
        >
          <b-form-checkbox
            v-model="form.store"
            switch
          >
            {{ $t('store.title') }} ?
          </b-form-checkbox>
        </b-col>
        <b-col
          v-if="form.store"
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.store_num"
            rules="integer"
            :label="$t('store.product_count')"
            is-required
          />
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <b-col
          md="6"
          class="mt-2"
        >
          <b-form-checkbox
            v-model="form.bot"
            switch
          >
            {{ $t('bot.title') }} ?
          </b-form-checkbox>
        </b-col>
        <b-col
          v-if="form.bot"
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.bot_num"
            rules="integer"
            :label="$t('bot.subscribers_count')"
            is-required
          />
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.price"
            rules="numeric"
            :label="$t('general.price')"
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.commission"
            rules="numeric"
            :label="$t('invoice.commission')"
          />
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <b-col md="6">
          <b-form-checkbox
            v-model="form.isFb"
            switch
          >
            {{ $t('general.fb') }} ?
          </b-form-checkbox>
        </b-col>
      </b-row>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-dark"
          :disabled="loading"
          @click="submit"
        >
          <b-spinner
            v-if="loading"
            small
            class="ml-1"
          />
          {{ $t('forms.save') }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import AdminPlansApi from '@/api/admin/plans'

export default {
  name: 'ProcessPlanModal',
  components: {
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    OkModal,
    BButton,
    BRow,
    BFormCheckbox,
    BCol,
    BSpinner,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    plan: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: null,
      form: {},
      loading: false,
    }
  },
  computed: {
    isEdit() {
      return !!this.plan?.id
    },
  },
  watch: {
    plan() {
      this.error = null
      this.setForm()
    },
  },
  mounted() {
    this.setForm()
  },
  methods: {
    async setForm() {
      if (this.isEdit) {
        this.form = { ...this.plan }
        this.form.isFb = this.plan?.media_type === 'fb'
        this.form.reply_num = this.plan.count
        this.form.price = this.plan.original_price
      } else {
        this.form = {
          name: '',
          isFb: true,
          price: 0,
          commission: 0,
          reply_num: 0,
          reply: true,
          bot: false,
          store: false,
          bot_num: 0,
          store_num: 0,
          multi_comment_num: 1,
          multi_comment: false,
        }
      }
    },
    async submit() {
      this.error = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        this.notifyError = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const form = { ...this.form }
        delete form.media_type
        form.media_type = this.form.isFb === true ? 'fb' : 'ig'
        await AdminPlansApi.update(form, this.form.id).then(res => {
          if (res.error === 0) {
            this.$notifySuccess(res.message)
            this.$emit('updated')
            this.$emit('input', false)
          }
        }).catch(e => { this.error = e })
          .finally(() => { this.loading = false })
      }
    },
  },
}
</script>
